import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function DataCard({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <article className={cn("v2-panel v2-motion-card-stagger p-4", className)}>
      {children}
    </article>
  );
}
